import { useEffect } from "react";
import styled from "styled-components";
import { ReactComponent as IconError } from "../Images/icon_toast_error.svg";
import { ReactComponent as IconSuccess } from "../Images/icon_toast_success.svg";

const ToastAlarm = ({ message, setToast, type }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      setToast(false);
      localStorage.removeItem("toast_enable");
    }, 3000);
    return () => {
      clearTimeout(timer);
    };
  }, [setToast]);
  return (
    <AlarmBox>
      {type === "success" ? (
        <IconSuccess style={{ marginLeft: "20px" }} />
      ) : (
        <IconError style={{ marginLeft: "20px" }} />
      )}
      <p>{message}</p>
    </AlarmBox>
  );
};

const AlarmBox = styled.div`
  width: 560px;
  height: 60px;
  position: absolute;
  // margin-top: 150px;
  top: 20px;
  background-color: #000000;
  border-radius: 10px;
  display: flex;
  align-items: center;
  > p {
    color: #ffffff;
    font-family: "notoSans-medium";
    font-size: 16px;
    margin-left: 8px;
  }
`;

export default ToastAlarm;
